<script setup lang="ts" generic="T extends { duid: string }">
import type { Component } from "ag-grid-community";
import { ref } from "vue";

import type { SimpleTableColumn } from "~/shared/types";

const props = defineProps<{
  columns: SimpleTableColumn<T>[];
  rows: T[];
}>();

const emit = defineEmits<{
  contextMenu: [MouseEvent, T];
}>();

const cellRefs = ref(new Map<string, Map<string, InstanceType<typeof Component> | null>>());

const setCellRef = (colTitle: string, row: T) => (el: InstanceType<typeof Component> | null) => {
  const rowDuid = row.duid;
  if (!cellRefs.value.has(colTitle)) {
    cellRefs.value.set(colTitle, new Map());
  }
  const colMap = cellRefs.value.get(colTitle);
  if (colMap) {
    colMap.set(rowDuid, el);
  }
};

const getCell = (colTitle: string, rowDuid: string) => cellRefs.value.get(colTitle)?.get(rowDuid);

defineExpose({
  getCell,
});
</script>

<template>
  <table class="w-full">
    <thead>
      <tr>
        <th
          v-for="(column, index) in props.columns"
          :key="index"
          class="sticky -top-3 z-20 pt-4 bg-std"
          :class="column.headerClasses">
          <div v-if="!column.hideTitle" class="my-2 select-none text-sm font-normal text-lt">{{ column.title }}</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(row, rowIndex) in props.rows"
        :key="rowIndex"
       
        @contextmenu="emit('contextMenu', $event, row)">
        <td v-for="(column, colIndex) in props.columns" :key="colIndex" :class="column.classes">
          <component
            :is="column.cell"
            :ref="setCellRef(column.title, row)"
            :row="row"
            v-bind="column.getCellArgs?.(row)" />
        </td>
      </tr>
    </tbody>
  </table>
</template>
